// platform _getDevice 相当: name == standId || name(末尾2文字除去) == standId。
// _2 サフィックスはキャッシュ名問題(#6095)対策。V1.4機(GG~/ik_C~)は _2 を付けない(#7682 実機確認済み)。
export function matchesStandId(
  deviceName: string | null | undefined,
  standId: string
): boolean {
  if (!deviceName) return false
  if (deviceName === standId) return true
  if (deviceName.length > 2 && deviceName.slice(0, -2) === standId) return true
  return false
}

// advertise名の sanitize: NUL終端で打ち切り、前後空白をtrimする（platform scan_dedup 相当）。
function sanitizeName(raw: string | null | undefined): string | null {
  if (raw == null) return null
  const cut = raw.split('\0')[0].trim()
  return cut.length > 0 ? cut : null
}

// iOSは前回接続時のGAP名をキャッシュして name(GATT名) に古い名前を返すことがある(#6095)。
// platform resolveScanName と同方針: 広告名(localName)を優先し、空のときだけ name(キャッシュ名)へ
// フォールバックする。これで ik_C0134(広告名) ↔ GG-LOCK-01(キャッシュ/GATT名) の揺れを吸収する。
// 広告名は固定長フィールドをNUL(0x00)でパディングして送られることがあるため、
// 両者ともsanitize（NUL終端で打ち切り＋前後trim）してから比較・返却する。
export function resolveScanName(
  localName: string | null | undefined,
  cachedName: string | null | undefined
): string | null {
  return sanitizeName(localName) ?? sanitizeName(cachedName)
}

// scan結果は累積で何度も emit されるため (deviceId, name) で間引く。
// 名前が空→確定の遷移は別キーとして扱い、確定名で再 emit させる。
export function createScanDedup(): (device: {
  deviceId: string
  name?: string
}) => boolean {
  const seen = new Set<string>()
  return (device) => {
    const key = `${device.deviceId}:${device.name ?? ''}`
    if (seen.has(key)) return false
    seen.add(key)
    return true
  }
}
